import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { NAVIGATION } from "@/constants";
import { useIsCurrentPageNumber } from "../../hooks/useIsCurrentPageNumber";
import { getItemClassName } from "./utils";
import { NavigationLink } from "./NavigationLink";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { NavigationIcon } from "./NavigationIcon";

export const NavigationMenu = () => {
  const isCurrentPageName = useIsCurrentPageNumber();

  return (
    <NavigationMenuPrimitive.Root
      skipDelayDuration={0}
      delayDuration={0}
      className="flex w-full items-center gap-4"
    >
      <NavigationMenuPrimitive.List className="flex items-center gap-4">
        {NAVIGATION.map((item) =>
          item.items ? (
            <DropdownMenuItem
              isCurrentPageName={isCurrentPageName(item)}
              key={item.name}
              item={item}
            />
          ) : (
            <NavigationLink to={item.href!}>
              <NavigationMenuPrimitive.Item
                className={getItemClassName(
                  isCurrentPageName(item),
                  "inline-flex cursor-pointer items-center rounded-md px-3 py-2 text-sm",
                )}
                key={item.name}
              >
                <NavigationIcon icon={item.icon} />
                {item.name}
              </NavigationMenuPrimitive.Item>
            </NavigationLink>
          ),
        )}
      </NavigationMenuPrimitive.List>
    </NavigationMenuPrimitive.Root>
  );
};
